module.exports = __webpack_public_path__ + "img/seq-tcga.56b3b9fc.svg";